// extracted by mini-css-extract-plugin
export default {"imgCont":"Error404Image_imgCont__jdVl-"};